import { ChangeDetectionStrategy, Component } from '@angular/core'
import { TutorialVideosEntity, TutorialVideosFacade } from 'gb-dashboard/staff/data-access-tutorial-videos'
import * as TutorialVideosActions from 'libs/gb-dashboard/staff/data-access-tutorial-videos/src/lib/+state/tutorial-videos.actions'
import { combineLatest, filter, map, skip, startWith } from 'rxjs'
import { NavigationEnd, Router } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { GbSidenavVisibilityService } from 'libs/gb-dashboard/core/feature/src/lib/gb-dashboard-sidenav/gb-sidenav-visibility.service'
import { matchesPattern } from '../gb-tutorial-popup-video/gb-tutorial-popup-video.utils'
import { HelpConstants } from 'libs/gb-dashboard/help/feature/src/lib/help.constants'

@UntilDestroy()
@Component({
  selector: 'gb-need-some-help',
  templateUrl: './gb-need-some-help.component.html',
  styleUrls: ['./gb-need-some-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbNeedSomeHelpComponent {
  sidenavVisible$ = this.gbSidenavVisibilityService.sidenavVisible$
  matchedTutorialVideos$ = combineLatest([
    this.tutorialVideosFacade.allTutorialVideos$.pipe(skip(1)),
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url),
    ),
  ]).pipe(
    map(([tutorialVideos, url]) => {
      return tutorialVideos.filter((tutorialVideo) =>
        matchesPattern(url, tutorialVideo.target.replace('/auction/', '/campaign/')),
      )
    }),
    untilDestroyed(this),
  )

  showingVideo$ = this.tutorialVideosFacade.showingVideo$

  constructor(
    private tutorialVideosFacade: TutorialVideosFacade,
    private router: Router,
    private gbSidenavVisibilityService: GbSidenavVisibilityService,
  ) {}

  openTutorialVideoPopUp(obs: TutorialVideosEntity[]) {
    this.tutorialVideosFacade.dispatch(
      TutorialVideosActions.showTutorialPopUpVideo({ videos: obs, target: obs[0].target }),
    )
  }

  goToHelpCenter(): void {
    this.router.navigate([`../${HelpConstants.HELP}`])
  }
}
